import React from 'react'
import PropTypes from 'prop-types';

export default function Navbar(props) {
    function expandThemeDiv(e) {
        const buttons = document.querySelectorAll('.buttons');
        e.target.classList.add('d-none')
        buttons.forEach(button => {
            button.classList.remove('d-none')
        });
        setTimeout(() => {
            buttons.forEach(button => {
                e.target.classList.remove('d-none')
                button.classList.add('d-none')
            });
        }, 5000)
    }
    return (
        <nav className={`navbar navbar-expand-lg navbar-${props.navBgColor} bg-${props.mode}`}>
            <div className="container-fluid">
                <a className="navbar-brand fw-bolder fs-4" href=''>{props.title}</a>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                </div>
                <div className='fs-5 fw-medium mx-3' style={{ color: props.mode === 'light' ? '#042743' : 'white' }} onClick={expandThemeDiv}>Change Theme</div>
                <div className='buttons mx-1 p-1 px-2 border border-5 bg-primary rounded-pill text-light d-none' onClick={props.changeTheme}>Blue</div>
                <div className='buttons mx-1 p-1 border  border-5 bg-success rounded-pill text-light d-none' onClick={props.changeTheme}>Green</div>
                <div className='buttons mx-1 p-1 px-2 border border-5 bg-danger rounded-pill text-light d-none' onClick={props.changeTheme}>Red</div>
                <div className='buttons mx-1 p-1 px-2 border border-5 bg-warning rounded-pill text-light d-none' onClick={props.changeTheme}>Yellow</div>
                <div className='buttons mx-1 p-1 border border-5 bg-white rounded-pill d-none' onClick={props.changeTheme}>Light</div>
                <div className='buttons mx-1 p-1 border border-5 px-2 bg-dark rounded-pill text-light d-none' onClick={props.changeTheme}>Dark</div>
            </div>
        </nav>
    )
}

Navbar.propTypes = {
    title: PropTypes.string.isRequired,
    aboutText: PropTypes.string
}

Navbar.defaultProps = {
    title: 'Rudra Text Editor',
    aboutText: 'About Us'
}
